import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import appStore from '../../store/AppStore'
import _ from 'lodash'
import green from '@material-ui/core/colors/green';

const styles = { 
  card:{
    marginTop: "15px",    
  },  
  cardheadertext:{
    fontSize: "18px",
    fontFamily: 'Noto Sans TC, sans-serif'
  },
  cardcontent:{
    paddingTop: "0px"
  },
  radiolabel:{
    height: "35px"
  }
}



class RadiosGroup extends Component {

  handleChange=(objectKey)=>(e)=>{
      appStore.setRadioGroupValue(e.target.value, objectKey); 
      
  }

  render() {
    const { classes, title, objectKey, selections } = this.props;
    
    
    return (   
          <React.Fragment>
          <CardHeader
            title={<Typography className={classes.cardheadertext}>{title}</Typography>}           
            className={classes.cardheader}
          />
          <CardContent
            className={classes.cardcontent}
          >
            <FormControl component="fieldset" className={classes.formControl}>          
              <RadioGroup
                aria-label={objectKey}
                name={objectKey}
                className={classes.group}
                value={appStore.postData[objectKey]}
                onChange={this.handleChange(objectKey)}
              >
              
              {_.map(selections, (item, key)=>{
                return<FormControlLabel 
                value={item.value}  
                control={<Radio color="primary" />} 
                label={<Typography>{item.label}</Typography>} 
                className={classes.radiolabel}
                key={key}
              />
              })}                         

              </RadioGroup>              
            </FormControl>
          </CardContent>        
        </React.Fragment>
    );
  }
}

export default withStyles(styles)(observer(RadiosGroup));
